<h1 translate
    matDialogTitle>
    check_perms_modal_title
</h1>

<mat-dialog-content (scroll)="onScroll($event)">
    <ng-container *ngIf="context.isNewEntry">
        <form [formGroup]="form">
            <ui-ad-search (selected)="username = $event ? $event.username + '@' + $event.domain : null"></ui-ad-search>
        </form>
    </ng-container>

    <ui-user-permissions *ngIf="username"
                         [username]="username"
                         [scrollBottom]="scrollBottom">
    </ui-user-permissions>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
